import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { ModalLoading } from "../../../../../../common/components/modal_loading";
import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import { useCallback, useEffect } from "react";
import { FormRadioGroupInput } from "../../../../../../common/components/masked_inputs/react_forms/form_radio_group_input";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { useForm } from "react-hook-form";
import { ClienteCentroCustoForm, ClienteCentroCustoSchema } from "../../../schemas/Clientes_cadastro/clienteCentroCustoCadastro";
import { zodResolver } from "@hookform/resolvers/zod";
import { ClienteCentroCusto } from "../../../../domain/models/clienteCentroCusto";
import { DropDownCentroCusto } from "../../../../../../common/components/dropdown_centro_custo";
import { LogTipoTabela } from "../../../../../../common/utils/log_tabela_tipo";
import { isNotNullOrUndefined } from "../../../../../../common/utils/utils";

type props = {
    open: boolean,
    saving: boolean,
    selectedClienteCentroCusto: ClienteCentroCusto | null,

    onSubmit: (form: ClienteCentroCustoForm) => void,
    onClose: () => void,
    onOpenChangeHistory: (id: number, tabelaTipo: LogTipoTabela) => void,
}

export const ClienteCentroCustoModal = ({
    open,
    saving,
    selectedClienteCentroCusto,
    onOpenChangeHistory,
    onClose,
    onSubmit,

}: props) => {

    const hookForm = useForm<ClienteCentroCustoForm>({
        mode: "onSubmit",
        reValidateMode: "onSubmit",
        resolver: zodResolver(ClienteCentroCustoSchema),
    });

    useEffect(() => {

        if (selectedClienteCentroCusto) {
            hookForm.setValue('idClienteCentroCusto', selectedClienteCentroCusto.idClienteCentroCusto);
            hookForm.setValue('idCliente', selectedClienteCentroCusto.idCliente);
            hookForm.setValue('principal', selectedClienteCentroCusto.principal);
            hookForm.setValue('unidade', selectedClienteCentroCusto?.unidade);
            hookForm.setValue('idCentroCusto', selectedClienteCentroCusto?.idCentroCusto);

        } else {
            hookForm.reset();
            hookForm.setValue('principal', 1);

        }
    }, [selectedClienteCentroCusto, hookForm]);

    const handleSubmit = useCallback((form: ClienteCentroCustoForm) => {
        if (!saving) {
            onSubmit(form);
            hookForm.reset();
        }

    }, [saving, onSubmit, hookForm]);

    const handleClose = useCallback(() => {
        if (!saving) onClose();
    }, [saving, onClose]);

    const handleChangeHistory = useCallback(() => {
        if (selectedClienteCentroCusto) {
            onOpenChangeHistory(selectedClienteCentroCusto.idClienteCentroCusto ?? 0, LogTipoTabela.CLIENTE_CENTRO_CUSTO);
        }
    }, [selectedClienteCentroCusto, onOpenChangeHistory]);

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            slotProps={{
                paper: {
                    component: 'form',
                    sx: { width: 400 },
                    onSubmit: hookForm.handleSubmit(handleSubmit)
                }

            }}
            sx={{
                "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "45rem",
                    },
                },
            }}>

            <DialogTitle>
                Centro de Custo Cliente
            </DialogTitle>

            <DialogContent>
                <ModalLoading loading={saving}  >
                    <FormContainer title={"Informações"} arrangement="fullRow">
                        <>
                            <FormRadioGroupInput
                                name='principal'
                                label='Centro Custo Principal'
                                options={[
                                    { id: 0, label: 'Não' },
                                    { id: 1, label: 'Sim' },

                                ]}
                                reactHookForm={hookForm} />

                            <DropDownCentroCusto
                                name='idCentroCusto'
                                label='Centro de Custo'
                                reactHookForm={hookForm}
                            />

                            <DefaultFormInput
                                name='unidade'
                                label='Unidade'
                                readOnly={false}
                                reactHookForm={hookForm}
                            />

                        </>
                    </FormContainer>

                </ModalLoading>
            </DialogContent>

            <DialogActions>
                <div className="w-full h-full items-center justify-end flex px-4 pb-4 gap-4">
                    <div>
                        {
                            isNotNullOrUndefined(selectedClienteCentroCusto) &&
                            <PrimaryButton
                                buttonColor="yellow"
                                onClick={handleChangeHistory}>
                                <span className="text-xs">
                                    Historico de alterações
                                </span>
                            </PrimaryButton>
                        }
                    </div>


                    <div className="flex flex-row gap-2">
                        <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                            <h1
                                className="text-sm text-black dark:text-white"
                                onClick={handleClose}>
                                Cancelar
                            </h1>
                        </div>

                        <div className="w-[120px]">
                            {saving ? (
                                <PrimaryButton
                                    buttonColor="primary-green">
                                    Salvando...
                                </PrimaryButton>
                            ) : (
                                <PrimaryButton
                                    type="submit"
                                    buttonColor="primary-green">
                                    Salvar
                                </PrimaryButton>
                            )}
                        </div>
                    </div>
                </div>
            </DialogActions>

        </Dialog>
    );
}